import api from 'poly-eshop4/eshop/ui/js/container';
import { KEYCODES } from 'poly-eshop4/eshop/ui/js/util/keycodes';

$(document).on('keydown', '[data-update-cart-position-quantity-rko]', function(event) {
  if (event.which === KEYCODES.ENTER) {
    if ($(this).val() === '0') {
      $(this).val('1');
    }
    api.updateQuantity($(this), 'cart');
  }
});

$(document).on('keyup', '[data-update-cart-position-quantity-rko]', function() {
  $(this).closest('form')[this.value !== this.defaultValue ? 'addClass' : 'removeClass']('ready');
});

$(document).on('blur', '[data-update-cart-position-quantity-rko]', function() {
  if (!$.isRefocusing) {
    if ($(this).val() === '0') {
      $(this).val('1');
    }
    api.updateQuantity($(this), 'cart');
  }
});
